module.exports = __webpack_public_path__ + "img/set-default-black.93609f0b.svg";